import React, { Component } from "react";
import { useForm, ValidationError } from "@formspree/react";

function ContactForm() {
  const [state, handleSubmit] = useForm("mwpoadwp");
  if (state.succeeded) {
    return (
      <div className="wpo-contact-title">
        <p>
          Thank you for reaching out! Our team will get back to you shortly.
        </p>
      </div>
    );
  }
  return (
    <form onSubmit={handleSubmit} className="form">
      <div className="row justify-content-center">
        <div className="col-lg-6 col-md-6 col-12">
          <div className="form-field">
            <input id="name" type="text" name="name" placeholder="Name" />
            <p />
            <ValidationError prefix="Name" field="name" errors={state.errors} />
          </div>
        </div>
        <div className="col-lg-6 col-md-6 col-12">
          <div className="form-field">
            <input
              id="lastname"
              type="text"
              name="lastname"
              placeholder="Lastname"
            />
            <p />
            <ValidationError
              prefix="Lastname"
              field="lastname"
              errors={state.errors}
            />
          </div>
        </div>
        <div className="col-lg-6 col-md-6 col-12">
          <div className="form-field">
            <input id="email" type="email" name="email" placeholder="Email" />
            <p />
            <ValidationError
              prefix="Email"
              field="email"
              errors={state.errors}
            />
          </div>
        </div>
        <div className="col-lg-6 col-md-6 col-12">
          <div className="form-field">
            <select className="form-control" type="text" name="subject">
              <option>Subject</option>
              <option>Subject1</option>
              <option>Subject2</option>
              <option>Subject3</option>
              <option>Subject4</option>
            </select>
            <p />
          </div>
        </div>
        <div className="col-lg-12">
          <div className="form-field">
            <textarea name="message" placeholder="Message"></textarea>
          </div>
        </div>
        <div className="col-lg-12">
          <div className="form-submit">
            <button
              type="submit"
              disabled={state.submitting}
              className="theme-btn"
            >
              Send Message
            </button>
          </div>
        </div>
      </div>
    </form>
  );
}

// class ContactForm extends Component {

//     state = {
//         name: '',
//         email: '',
//         subject: '',
//         lastname: '',
//         events: '',
//         notes: '',
//         error: {}
//     }

//     changeHandler = (e) => {
//         const error = this.state.error;
//         error[e.target.name] = ''

//         this.setState({
//             [e.target.name]: e.target.value,
//             error
//         })
//     }

//     subimtHandler = (e) => {
//         e.preventDefault();

//         const { name,
//             email,
//             subject,
//             lastname,
//             events,
//             notes, error } = this.state;

//         if (name === '') {
//             error.name = "Please enter your name";
//         }
//         if (email === '') {
//             error.email = "Please enter your email";
//         }
//         if (subject === '') {
//             error.subject = "Please enter your subject";
//         }
//         if (lastname === '') {
//             error.lastname = "Please enter your Lastname";
//         }
//         if (events === '') {
//             error.events = "Select your event list";
//         }
//         if (notes === '') {
//             error.notes = "Please enter your note";
//         }

//         if (error) {
//             this.setState({
//                 error
//             })
//         }
//         if (error.name === '' && error.email === '' && error.email === '' && error.lastname === '' && error.subject === '' && error.events === '' && error.notes === '') {
//             this.setState({
//                 name: '',
//                 email: '',
//                 subject: '',
//                 events: '',
//                 notes: '',
//                 error: {}
//             })
//         }
//     }

//     render(){
//         const { name,
//             email,
//             subject,
//             lastname,
//             error } = this.state;

//         const [state, handleSubmit] = useForm("mwpoadwp");

//         return(

// <form onSubmit={this.subimtHandler} className="form">
//     <div className="row justify-content-center">
//         <div className="col-lg-6 col-md-6 col-12">
//             <div className="form-field">
//                 <input value={name} onChange={this.changeHandler} type="text" name="name" placeholder="Name"/>
//                 <p>{error.name ? error.name : ''}</p>
//             </div>
//         </div>
//         <div className="col-lg-6 col-md-6 col-12">
//             <div className="form-field">
//                 <input value={lastname} onChange={this.changeHandler} type="text" name="lastname" placeholder="Lastname"/>
//                 <p>{error.lastname ? error.lastname : ''}</p>
//             </div>
//         </div>
//         <div className="col-lg-6 col-md-6 col-12">
//             <div className="form-field">
//                 <input onChange={this.changeHandler} value={email} type="email" name="email" placeholder="Email"/>
//                 <p>{error.email ? error.email : ''}</p>
//             </div>
//         </div>
//         <div className="col-lg-6 col-md-6 col-12">
//             <div className="form-field">
//                 <select className="form-control" onChange={this.changeHandler} value={subject} type="text" name="subject">
//                     <option >Subject</option>
//                     <option >Subject1</option>
//                     <option >Subject2</option>
//                     <option >Subject3</option>
//                     <option >Subject4</option>
//                 </select>
//                 <p>{error.subject ? error.subject : ''}</p>
//             </div>
//         </div>
//         <div className="col-lg-12">
//             <div className="form-field">
//                 <textarea name="message" placeholder="Message"></textarea>
//             </div>
//         </div>
//         <div className="col-lg-12">
//             <div className="form-submit">
//                 <button type="submit" className="theme-btn">Send Message</button>
//             </div>
//         </div>
//     </div>
// </form>
//         )
//     }

// }
export default ContactForm;
